import angular from 'angular';
import { Lang } from 'Roblox';
import avatarModule from '../avatarModule';

/*
    Controls the outfits section of the avatar page
*/
function outfitsController($scope, avatarService, avatarConstantService) {
  'ngInject';

  $scope.loading = false;
  $scope.items = [];
  $scope.isOutfitCostumeMessage = true;

  $scope.appMeta = {
    isI18nEnabled: Lang.AvatarResources || false
  };

  let moreItems = true;
  let pageNumber = 1;
  let itemsPerPage = 50;

  $scope.emptyMessage = function() {
    if ($scope.$parent.bundlesEnabledForUser) {
      return avatarConstantService.outfits.costumeMessages.emptyMessage;
    } else {
      return avatarConstantService.outfits.outfitMessages.emptyMessage;
    }
  };

  var getFirstPage = function() {
    // TODO cancel other requests
    pageNumber = 1;
    moreItems = true;
    $scope.loading = false;
    $scope.items = [];
    $scope.getNextPage();
  };

  $scope.getNextPage = function() {
    if ($scope.selectedTab.tabType !== 'Outfits' && $scope.selectedTab.tabType !== 'Costumes') {
      return;
    }

    if ($scope.loading || !moreItems) {
      return;
    }

    $scope.loading = true;

    if ($scope.selectedTab.tabType === 'Outfits') {
      avatarService
        .getOutfits($scope.avatarDataModel.userId, pageNumber, itemsPerPage, true)
        .then(function(response) {
          successfullyRetrievedOutfits(response);
        }, failedToRetrieveOutfits);
    } else if ($scope.selectedMenu !== null) {
      if ($scope.selectedMenu.name === 'MyCostumes') {
        avatarService
          .getOutfits($scope.avatarDataModel.userId, pageNumber, itemsPerPage, true)
          .then(function(response) {
            successfullyRetrievedOutfits(response);
          }, failedToRetrieveOutfits);
      } else if ($scope.selectedMenu.name === 'PresetCostumes') {
        avatarService
          .getOutfits($scope.avatarDataModel.userId, pageNumber, itemsPerPage, false)
          .then(function(response) {
            successfullyRetrievedOutfits(response);
          }, failedToRetrieveOutfits);
      }
    }

    function successfullyRetrievedOutfits(response) {
      $scope.loading = false;
      var filteredItemsCount = response.filteredCount == null ? 0 : response.filteredCount;
      moreItems = response.data.length + filteredItemsCount === itemsPerPage;
      pageNumber += 1;
      angular.forEach(response.data, function(item) {
        item.type = 'Outfit';
        $scope.addItemThumbnailAndLink(item);
      });
      $scope.items = $scope.items.concat(response.data);
    }

    function failedToRetrieveOutfits() {
      let outfitCostumeMessages = $scope.$parent.bundlesEnabledForUser
        ? avatarConstantService.outfits.costumeMessages.emptyMessage
        : avatarConstantService.outfits.outfitMessages.emptyMessage;
      $scope.systemFeedback.error(outfitCostumeMessages.failedToLoadOutfits);
    }
  };

  $scope.$on(avatarConstantService.events.outfitsChanged, function(event, obj) {
    getFirstPage();
  });

  $scope.$on(avatarConstantService.events.outfitDeleted, function(event, itemDeleted) {
    angular.forEach($scope.items, function(item, index) {
      if (item.id === itemDeleted.id) {
        $scope.items.splice(index, 1);
      }
    });
  });

  $scope.$on(avatarConstantService.events.menuClicked, function(event, obj) {
    let {tab} = obj;
    if (tab.name === 'Outfits' || tab.name === 'Costumes') {
      getFirstPage();
      let outfitSingular = tab.name === 'Outfits' ? 'Outfit' : 'Costume';
      $scope.createNewOutfitLabel = avatarConstantService.outfits.createNewOutfit(outfitSingular);
    }
  });
}

avatarModule.controller('outfitsController', outfitsController);

export default outfitsController;
